import styled from 'styled-components/macro';

export const StyledLoadingMessage = styled.div`
  display: flex;
  align-items: center;

  .icon {
    margin-right: 0.5rem;
  }

  .loading-text {
    font-size: 14px;
  }
`;
